export function dateToTimeOnly(date: Date): string {
  // Extract hours and minutes from the Date object
  const hours = date.getHours().toString().padStart(2, "0")
  const minutes = date.getMinutes().toString().padStart(2, "0")

  // Return the time in HH:mm format
  return `${hours}:${minutes}`
}
